/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { types } from 'mobx-state-tree';
import VisSlotDataItemHandler from '../VisSlotDataItemHandler';
const MemUtil = require('gemini/lib/@waca/dashboard-common/dist/utils/MemUtil');

export default types
	.model('SlotsModel', {
		slotInfo: types.optional(types.array(types.frozen()), [])
	})
	.volatile((self) => ({
		visSlotDataItemHandlersMap:{},
		content: null,
		visualization: null,
		dashboardAPI: null,
		/**
		 * @param {Object} slot - slot api
		 * @return {Object} - SlotDataItemHandler
		 */
		getSlotDataItemHandler(slot, indexInSlot) {
			if(!self.content) {
				return null;
			}
			if(!self.visualization){
				self.setVisualization();
			}
			const handlerKey = [slot.getDefinition().getDatasetIdList()[0], slot.getDefinition().getId(), indexInSlot].join(':');

			//Re-use or allocate a slotDataItemHandler.
			let slotDataItemHandler = self.visSlotDataItemHandlersMap[handlerKey];
			if (!slotDataItemHandler || MemUtil.isDestroyed(slotDataItemHandler.slot)) {
				let fnAcceptsOlapV2;
				if (self.visualization.getType() === 'Crosstab') {
					const utils = self.content.getFeature('VisDnD.utils');
					if (utils) {
						fnAcceptsOlapV2 = utils.acceptsOlapV2;
					}
				}
				const slotActions = self.content.getFeature('SlotActions');
				const cbGetActionsForSlot = slotActions.getSlotActionList.bind(slotActions);
				slotDataItemHandler = new VisSlotDataItemHandler(slot, indexInSlot, cbGetActionsForSlot, self.visualization, self.dashboardApi, self.content, fnAcceptsOlapV2);
				self.setVisSlotDataItemHandler(handlerKey, slotDataItemHandler);
			}
			return slotDataItemHandler;
		}
	}))
	.views((self) => ({
		/**
		 * @return {array} slot info
		 */
		getSlotInfo() {
			return self.slotInfo;
		}
	}))
	.actions((self) => {
		let eventCallback = null;
		return {
			beforeDestroy() {
				self.clearEvents();
			},
			setContent(content) {
				self.content = content;
			},
			setUpEvents(callback) {
				if(self.content) {
					eventCallback = callback;
					self.content.on('change', eventCallback);
					self.visDefinitions = self.dashboardApi.getFeature('VisDefinitions');
					self.visDefinitions.on('refresh:definition', eventCallback);
				}
			},
			setVisualization() {
				if(self.content) {
					self.visualization = self.content.getFeature('Visualization');
				} else {
					self.visualization = null;
				}
			},
			setDashboardApi(dashboardApi) {
				self.dashboardApi = dashboardApi;
			},
			setVisSlotDataItemHandler(handlerKey, slotDataItemHandler) {
				self.visSlotDataItemHandlersMap[handlerKey] = slotDataItemHandler;
			},
			setSlotInfo(slotInfo = []) {
				self.slotInfo = slotInfo;
			},
			clear() {
				self.clearEvents();
				self.content = null;
				self.visualization = null;
				self.slotInfo = [];
				self.visSlotDataItemHandlersMap = {};
			},
			clearEvents() {
				if(self.content) {
					self.content.off('change', eventCallback);
					self.visDefinitions.off('refresh:definition', eventCallback);
					eventCallback = null;
				}
			}
		};
	});



// WEBPACK FOOTER //
// ./src/js/models/SlotsModel.js